import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras'

import Game from './Game';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const Bracket12: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%' }}>
            <Grid columns="repeat(8, max-content)">
                <Grid rows="repeat(34, 1fr)">
                    <Cell style={{ gridRow: '2 / 4' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '6 / 8' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 12' }}>
                        <Game game={games[2]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '14 / 16' }}>
                        <Game game={games[3]} topLabel bottomLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '17 / 18' }} align="flex-end" ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>

                    <Cell style={{ gridRow: '19 / 21' }}>
                        <Game game={games[8]} topLabel bottomLabel/>
                    </Cell>
                    <Cell style={{ gridRow: '23 / 25' }}>
                        <Game game={games[9]} topLabel bottomLabel/>
                    </Cell>
                    <Cell style={{ gridRow: '27 / 29' }}>
                        <Game game={games[10]} topLabel bottomLabel/>
                    </Cell>
                    <Cell style={{ gridRow: '31 / 33' }}>
                        <Game game={games[11]} topLabel bottomLabel/>
                    </Cell>
                </Grid>
                <Grid columns="1fr" rows="repeat(34, 1fr)">
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[4]} topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '5 / 7' }}>
                        <Game game={games[5]} topLabel  />
                    </Cell>
                    <Cell style={{ gridRow: '9 / 11' }}>
                        <Game game={games[6]} topLabel  />
                    </Cell>
                    <Cell style={{ gridRow: '13 / 15' }}>
                        <Game game={games[7]} topLabel  />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '20 / 24' }}>
                        <Game game={games[14]} />
                    </Cell>
                    <Cell style={{ gridRow: '28 / 32' }}>
                        <Game game={games[15]} />
                    </Cell>
                </Grid>
                <Grid columns="1fr" rows="repeat(34, 1fr)">
                    <Cell style={{ gridRow: '2 / 6' }}>
                        <Game game={games[12]} />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 14' }}>
                        <Game game={games[13]} />
                    </Cell>

                    {/* Toilet Bowl Heading */}

                    <Cell style={{ gridRow: '17 / 19' }} align="center" justify="flex-end" pe="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">TOILET BOWL BRACKET</H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '22 / 26' }}>
                        <Game game={games[16]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '30 / 34' }}>
                        <Game game={games[17]} bottomLabel/>
                    </Cell>
                </Grid>
                <Grid columns="1fr" rows="repeat(34, 1fr)">
                    <Cell style={{ gridRow: '4 / 12' }}>
                        <Game game={games[18]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '15 / 17' }} bgColor="tertiary200">
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>

                    <Cell style={{ gridRow: '17 / 19' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '19 / 21' }} bgColor="tertiary200">
                        <Game game={tbGames[1]} bottomLabel topLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '24 / 32' }}>
                        <Game game={games[19]} />
                    </Cell>
                </Grid>
                <Grid columns="1fr" rows="repeat(34, 1fr)">
                    <Cell style={{ gridRow: '8 / 12' }}>
                        <ByGame />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '15 / 16' }} bgColor="tertiary200">
                    </Cell>

                    <Cell style={{ gridRow: '16 / 20' }} bgColor="tertiary200">
                        <Game game={tbGames[2]} />
                    </Cell>

                    <Cell style={{ gridRow: '20 / 21' }} bgColor="tertiary200" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '28 / 34' }}>
                        <Game game={games[20]}
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']} 
                            bottomLabel
                        />
                    </Cell>
                </Grid>
                <Grid columns="1fr" rows="repeat(34, 1fr)">
                    <Cell style={{ gridRow: '8 / 8' }}>
                        <ByGame />
                    </Cell>


                    <Cell style={{ gridRow: '15 / 18' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '19 / 21' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '18 / 18' }} bgColor="tertiary200">
                        <ByGame tb color="black" />
                    </Cell>

                    <Cell style={{ gridRow: '19 / 21' }} bgColor="tertiary200" />

                    <Cell style={{ gridRow: '28 / 31' }}>
                        <ByGame position="bottom" />
                    </Cell>
                </Grid>
                <Grid columns="1fr" rows="repeat(34, 1fr)">
                    <Cell style={{ gridRow: '8 / 31' }}>
                        <Game game={games[21]} />
                    </Cell>
                </Grid>
                <Grid columns="1fr" rows="repeat(34, 1fr)" className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '18 / 20' }} width="100px">
                        <ByGame
                            trophy
                            color={['tertiary600', 'tertiary800']}
                            loserTrophy
                        />
                    </Cell>
                    <Cell style={{ gridRow: '21 / 23' }}>
                        <Game game={games[22]} />
                    </Cell>
                </Grid>

                {games[21].winner && games[21].team2.id === games[21].winner.id && (
                    <Grid columns="1fr" rows="repeat(34, 1fr)" className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '16 / 23' }} width="260px">
                            <Game game={games[22]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows="repeat(34, 1fr)" className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '18 / 20' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket12;
